import type { FC } from 'react';

type ConsultantPartnershipBadgeProps = {
  name: string;
  logo: string | null;
};

/**
 * "in partnership with [consultant logo]" card shown in the main sidebar
 * when the current workspace is a client of a consultant organization.
 */
export const ConsultantPartnershipBadge: FC<
  ConsultantPartnershipBadgeProps
> = ({ name, logo }) => (
  <div className="mx-2 flex items-center justify-center gap-[10px] rounded-[8px] border border-neutral-200 bg-white p-[8px]">
    <span className="shrink-0 whitespace-nowrap text-[8px] italic leading-[1.6] text-neutral-900 tracking-[0.12px]">
      in partnership with
    </span>
    {logo ? (
      <img
        src={`${import.meta.env.VITE_API_URL || 'http://localhost:3000'}${logo}`}
        alt={name}
        className="max-h-10 w-auto max-w-[140px] object-contain"
      />
    ) : (
      <span className="text-xs font-medium text-neutral-900">{name}</span>
    )}
  </div>
);
